import Demo from './demo-screen';

export default Demo;